import React from "react";
import { Form, Input, Radio, Divider, Select } from "antd";
import RadioGroup from "antd/lib/radio/group";
import QuestionPopup from "../../../../common/components/questionPopup/questionPopup";
import PhoneNumberMask from "../../../../common/inputs/AuthorizationInputs";
import PhysicalForm from "./formSections/PhysicalForm";
import LegalForm from "./formSections/LegalForm";
import IndividForm from "./formSections/IndividForm";
import moment from "moment";
import { BankForm } from "./formSections/BankForm";

const { Option } = Select;

const customerPopupInfo = (
  <div>
    В зависимости от того, что вы
    <br /> выберите, нужно будет указать
    <br /> разную информацию. Также от этого <br />
    зависит, будете ли вы получать
    <br /> бухгалтерские документы.
    <br />
    <br />
    <strong>Физическое лицо:</strong> мы не будем
    <br /> отправлять вам бухгалтерскую
    <br /> документацию.
    <br />
    <br />
    <strong>Юридическое лицо:</strong> укажите ИНН, <br /> КПП и адреса. Эта
    информация <br />
    нужна для документов, которые вы
    <br /> будете получать. Обратите внимание,
    <br /> что изменять ИНН нельзя.
    <br />
    <br />
    <strong>Индивидуальный предприниматель:</strong>
    <br /> укажите ИНН и адреса. Эта
    <br /> информация нужна для документов,
    <br /> которые вы будете получать.
    <br /> Обратите внимание, что изменять
    <br />
    ИНН нельзя.
  </div>
);

const phonePopupInfo = (
  <div>
    По указанному номеру телефона
    <br />в приложении заказчика будет
    <br />
    доступна информация и документы
    <br />
    по заявкам, предложениям, заказам
  </div>
);

const requiredRule = {
  required: true,
  message: "Поле, обязательное для заполнения"
};

class AddCustomerForm extends React.Component {
  state = {
    autoSearchFields: null,
    subjectKey: undefined
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.errors && this.props.errors !== prevProps.errors) {
      const { errors } = this.props;

      let obj = {};
      if (
        errors.response &&
        errors.response.data &&
        errors.response.data.message
      ) {
        Object.keys(errors.response.data.errors).forEach(key => {
          const value = this.props.form.getFieldValue(key);
          obj[key] = {
            value: value,
            errors: [new Error(errors.response.data.errors[key])]
          };
        });
      }

      this.props.form.setFields({ ...obj });
      this.props.clearAddCustomerErrors();
    }
  }

  handleChange = fields => {
    fields &&
      this.setState({ ...this.state, autoSearchFields: fields }, () => {
        let obj = {};
        obj["dadataSearch"] = fields.key;
        obj["nameLegal"] = fields.name;
        obj["companyAddress"] = fields.address;
        obj["registrationDate"] =
          (fields.dateRegistered && moment(fields.dateRegistered)) || null;
        obj["inn"] = fields.inn;
        obj["ogrn"] = fields.ogrn;
        obj["status"] =
          fields.isActing && fields.isActing === "ACTIVE"
            ? "Действующая"
            : null;
        obj["subjectKey"] =
          fields.opfShort && fields.opfShort === "ИП" ? "individ" : "legal";

        this.props.form.setFieldsValue(obj);
      });
  };

  onSubjectChange = e => {
    this.setState(
      { autoSearchFields: null, subjectKey: e.target.value },
      () => {
        this.props.dadataClearSelected();
        this.props.form.setFieldsValue({ subjectKey: e.target.value });
      }
    );
  };

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const subjectId = getFieldValue("subjectKey");
    const prefixPhoneCode = getFieldDecorator("phoneCode", {
      initialValue: "+7"
    })(
      <Select
        style={{ width: 78, backgroundColor: "#fff" }}
        dropdownMatchSelectWidth={false}
        optionLabelProp="value"
        placeholder="Код"
      >
        <Option value="+7">+7 (Россия)</Option>
        <Option value="+380">+380 (Украина)</Option>
        <Option value="+375">+375 (Беларусь)</Option>
        <Option value="+77">+77 (Казахстан)</Option>
        <Option value="+994">+994 (Азербайджан)</Option>
        <Option value="+374">+374 (Армения)</Option>
        <Option value="+995">+995 (Грузия)</Option>
      </Select>
    );

    return (
      <Form layout="inline" className="add-customer-form">
        <div className="add-customer-form__unit">
          <span className="add-customer-form__label">Заказчик:</span>
          <div className="add-customer-form__item">
            {getFieldDecorator("subjectKey")(
              <RadioGroup name="subject" onChange={this.onSubjectChange}>
                <Radio value="physical">Физическое лицо</Radio>
                <Radio value="legal">Юридическое лицо</Radio>
                <Radio value="individ">ИП</Radio>
              </RadioGroup>
            )}
            <QuestionPopup
              width="24px"
              height="24px"
              trigger="click"
              fill="#00a8ff"
              position="bottomLeft"
            >
              {customerPopupInfo}
            </QuestionPopup>
          </div>
        </div>
        {subjectId && subjectId === "physical" ? (
          /* Поля для физ лица */
          <PhysicalForm form={this.props.form} />
        ) : subjectId === "legal" ? (
          /* Поля для юр лица */
          <LegalForm
            form={this.props.form}
            subjectId={subjectId}
            handleChange={this.handleChange}
            autoSearchFields={this.state.autoSearchFields}
          />
        ) : subjectId === "individ" ? (
          /* Поля для ИП */
          <IndividForm
            form={this.props.form}
            subjectId={subjectId}
            handleChange={this.handleChange}
            autoSearchFields={this.state.autoSearchFields}
          />
        ) : null}
        {subjectId ? (
          <>
            <Divider />
            <div className="add-customer-form__unit">
              <span className="add-customer-form__label">
                Номер телефона аккаунта:
              </span>
              <div className="add-customer-form__item add-customer-form__phone">
                <Form.Item>
                  {getFieldDecorator("phoneNumber", {
                    rules: [requiredRule]
                  })(
                    <PhoneNumberMask
                      autoComplete="off"
                      name="phoneNumber"
                      mask="(###) ###-##-##"
                      addonBefore={prefixPhoneCode}
                      maxLength={15}
                      placeholder="Укажите номер телефона"
                    />
                  )}
                </Form.Item>
                <QuestionPopup
                  width="24px"
                  height="24px"
                  trigger="click"
                  fill="#00a8ff"
                  position="bottomLeft"
                  style={{ marginLeft: 16 }}
                >
                  {phonePopupInfo}
                </QuestionPopup>
              </div>
            </div>
            <div className="add-customer-form__unit">
              <span className="add-customer-form__label">E-mail:</span>
              <div className="add-customer-form__item">
                <Form.Item>
                  {getFieldDecorator("email", {
                    rules: [requiredRule]
                  })(
                    <Input
                      className="add-customer-form__input"
                      placeholder="Укажите e-mail"
                      style={{ width: 368 }}
                    />
                  )}
                </Form.Item>
              </div>
            </div>
            {getFieldValue("subjectKey") &&
              getFieldValue("subjectKey") !== "physical" && (
                <div className="add-customer-form__unit">
                  <span className="add-customer-form__label">Сайт:</span>
                  <div className="add-customer-form__item">
                    <Form.Item>
                      {getFieldDecorator("site")(
                        <Input
                          className="add-customer-form__input"
                          placeholder="Укажите сайт"
                          style={{ width: 368 }}
                        />
                      )}
                    </Form.Item>
                  </div>
                </div>
              )}
          </>
        ) : null}
        {subjectId && <BankForm form={this.props.form} />}
      </Form>
    );
  }
}

export default Form.create({
  name: "AddCustomerForm",
  onFieldsChange(props, fields) {
    console.log(fields)
    props.handleFieldsChange(fields);
  },
  mapPropsToFields(props) {
    let obj = {};
    if (props) {
      let { data, dadata } = props;

      if (dadata) {
        obj["nameLegal"] = Form.createFormField({
          value: dadata.name || undefined
        });
        obj["dadataSearch"] = Form.createFormField({
          value: dadata.key || undefined
        });
        obj["companyAddress"] = Form.createFormField({
          value: dadata.address || undefined
        });
        obj["companyAddress"] = Form.createFormField({
          value: dadata.address || undefined
        });
        obj["registrationDate"] = Form.createFormField({
          value: moment(dadata.dateRegistered) || undefined
        });
        obj["inn"] = Form.createFormField({ value: dadata.inn || undefined });
        obj["kpp"] = Form.createFormField({ value: dadata.kpp || undefined });
        obj["ogrn"] = Form.createFormField({ value: dadata.ogrn || undefined });
        // obj['eio'] = {value: dadata. || undefined}

        obj["status"] = Form.createFormField({
          value: dadata.isActing === "ACTIVE" ? "Активный" : undefined
        });
      }

      if (data) {
        Object.keys(data).forEach(key => {
          obj[key] = Form.createFormField({
            ...data[key],
            value: data[key].value 
          });
        });
      }
    }
    return obj;
  }
})(AddCustomerForm);
